export default {
    setting: {
        profileAuthSetting: "Mipangilio ya Uthibitishaji wa Wasifu",
        logInOutSetting: "Mipangilio ya Kuingia/Toka",
        autoLogout: "Ondoka kiotomatiki",
        unsuccessfulLoginAttempt: "Jaribio la Kuingia Lisilofanikiwa",
        unsuccessfulLoginLockPeriod: "Kipindi cha Kufungia nje hakijafaulu",
        passCriteriaSetup: "Uwekaji wa Vigezo vya Nenosiri",
        passLength: "Urefu wa nenosiri",
        noUniquePassRequired: "Idadi ya manenosiri ya kipekee inahitajika",
        maxPassAge: "Umri wa juu wa nenosiri",
        acceptableRangeOfChars: "Aina zinazokubalika za wahusika ",
        upperCase: "Kesi ya juu",
        lowerCase: "Kesi ya chini",
        numbers: "Nambari",
        specialChars: "Wahusika maalum",
        uniqueSymbols: "Alama za kipekee",
        loadingData: "Inapakia Data...",
        currency: "Sarafu",
        codeActivationTime: "Muda wa Kuanzisha Msimbo",
        changeGlobalSetting: "Badilisha Mipangilio ya Ulimwenguni",
        globalSetting: "Mipangilio ya Ulimwenguni",
        generalSetting: "Mipangilio ya Jumla",
        hour: "Saa",
        days: "Siku",
        minutes: "Dakika",
        perDay: "Kwa siku",
        perHour: "Kwa Saa",
        customised: "Imebinafsishwa",
        areaUnit: "Kitengo cha Eneo",
        weightUnit: "Kitengo cha Uzito",
    
        smallFarm: "Shamba dogo",
        inclusive: "Inayojumuisha",
        from: "Kutoka",
        to: "Hadi",
        mediumFarm: "Shamba la kati",
        largeFarm: "Shamba kubwa",
        requiredMessage: "Sehemu hii inahitajika",
        nonNegativeMessage: "Sehemu hii inapaswa kuwa sio hasi",
        fieldToGreaterThanFrom:
          "Sehemu hii inapaswa kuwa kubwa kuliko sehemu 'Kutoka'",
        fieldToGreaterThanFromMedium:
          "Sehemu hii inapaswa kuwa kubwa kuliko sehemu 'Hadi' ya shamba dogo",
        fieldToGreaterThanMediumTo:
          "Sehemu hii inapaswa kuwa kubwa kuliko sehemu 'Hadi' ya shamba la kati",
      },
}